import React from 'react'
import useMediaQuery from '../../../utils/useMediaQuery'
import AppSlider from '../../atoms/appSlider/appSlider'
import ModalPreGameCard from './modalPreGameCard'

import menstruacion from '../../../assets/images/games/personajes/menstruacion.png'
import images_modal from '../../../assets/images/games/modal/images'
import images_pad from '../../../assets/images/games/pad/images'

import Button from '../../atoms/button/button'
import pushPreGameMetric from './pushMetric'

import { ReplicaImageMBSnake, textCountry } from './replica-pregame'

const Title = ({ mobile = false }) => {
  return (
    <div>
      <h2 className="f-modal-pre-game__card__title">
        ¡Bienvenida al{mobile ? <br /> : null} Planeta Menstruación!
      </h2>
      {mobile ? (
        <>
          <br />
          <p className="--center">¡Es momento de retarte!</p>{' '}
        </>
      ) : null}
    </div>
  )
}
const Controls = ({ className = '', mobile = false }) => {
  return (
    <div>
      <p className={className}>
        <b>
          {mobile ? (
            <>
              {textCountry.text12} el pad de tu pantalla para mover las piezas en el escenario.
            </>
          ) : (
            <>
              {textCountry.text12} las flechas de tu teclado para mover la toalla en el escenario
            </>
          )}
        </b>
      </p>
      <br />
      <div className={'f-modal-pre-game__controls ' + className}>
        <div className="f-modal-pre-game__controls__row">
          <img src={images_pad.pad_left} className="f-modal-pre-game__pad-icon" />
          <p>
            <b className="--accent">Tecla de flecha izquierda:</b> {textCountry.text4} la
            toalla a la izquierda
          </p>
        </div>
        <br />
        <div className="f-modal-pre-game__controls__row">
          <img src={images_pad.pad_right} className="f-modal-pre-game__pad-icon" />
          <p>
            <b className="--accent">Tecla de flecha derecha:</b> {textCountry.text4} la toalla
            a la derecha
          </p>
        </div>
        <br />
        <div className="f-modal-pre-game__controls__row">
          <img src={images_pad.pad_down} className="f-modal-pre-game__pad-icon" />
          <p>
            <b className="--accent">Tecla de flecha {textCountry.text17} abajo:</b> {textCountry.text4} la toalla
            hacia abajo
          </p>
        </div>
        <br />
        <div className="f-modal-pre-game__controls__row">
          <img src={images_pad.pad_up} className="f-modal-pre-game__pad-icon" />
          <p>
            <b className="--accent">Tecla de flecha {textCountry.text17} arriba:</b> {textCountry.text5} la toalla
            hacia arriba
          </p>
        </div>
      </div>
    </div>
  )
}
const MobileVersion = ({ onEnd }) => {
  const handlerCallToAction = e => {
    pushPreGameMetric('snake', 'click', e.target.innerText)
    onEnd()
  }
  return (
    <AppSlider settings={{ infinite: false }}>
      <ModalPreGameCard onCancel={onEnd}>
        <div className="f-modal-pre-game__mobile-wrapper">
          <Title mobile={true} />
          <br />
          <figure>
            <img src={images_modal.snake_preview_2} />
          </figure>
          <br />
          <p className="--center --medium">
            {textCountry.text4} la toalla alrededor del escenario, {textCountry.text9} todas las gotas de
            sangre que {textCountry.text10}, y la toalla crecerá. ¡Entre más larga la toalla,
            más difícil será controlarla! {textCountry.text8} chocar contra las paredes para
            no perder.
          </p>
        </div>
      </ModalPreGameCard>
      <ModalPreGameCard onCancel={onEnd}>
        <div className="f-modal-pre-game__mobile-wrapper">
          <Title mobile={true} />
          <br />
          <figure>
            <ReplicaImageMBSnake/>
          </figure>
          <br />
          <p className="--text-center --medium">
            <b>Los personajes de Nosotras y la V </b>serán tu Bonus Track,
            ¡{textCountry.text11} todos!
          </p>
        </div>
      </ModalPreGameCard>
      <ModalPreGameCard onCancel={onEnd}>
        <div className="f-modal-pre-game__mobile-wrapper">
          <Title mobile={true} />
          <br />
          <Controls className="--text-center" mobile={true} />
          <br />
          <br />
          <Button onClick={handlerCallToAction} title="¡Quiero jugar ya!">
            ¡Quiero jugar ya!
          </Button>
        </div>
      </ModalPreGameCard>
    </AppSlider>
  )
}
const PcVersion = ({ onEnd }) => {
  const handlerCallToAction = e => {
    pushPreGameMetric('snake', 'click', e.target.innerText)
    onEnd()
  }
  return (
    <AppSlider settings={{ infinite: false }}>
      <ModalPreGameCard onCancel={onEnd}>
        <div>
          <Title />
          <br /> <br />
          <div className="f-modal-pre-game__flex-wrapper">
            <figure>
              {/* <img src={snakePreview1} /> */}
            <ReplicaImageMBSnake/>
            </figure>
            <aside>
              <div className="f-modal-pre-game__flex-wrapper">
                <figure>
                  <img src={menstruacion} />
                </figure>
                <aside>
                  <p>
                    <b>¡Es momento de retarte!</b>
                  </p>
                  <br /> <br />
                  <p>
                    <b>{textCountry.text4} la toalla alrededor del escenario,</b> {textCountry.text9} todas
                    las gotas de sangre que {textCountry.text10}, y la toalla crecerá. ¡Entre
                    más larga la toalla, más difícil será controlarla!{' '}
                    <b>{textCountry.text8} chocar contra las paredes para no perder.</b>
                  </p>
                </aside>
              </div>
              <br />
              <p>
                <b>Los personajes de Nosotras y la V </b>serán tu Bonus Track,
                ¡{textCountry.text11} todos!
              </p>
              <br />
              <p>
                <b>Los Personajes Nosotras:</b> duplican tus puntos. “V”:
                triplica tus puntos.
              </p>
            </aside>
          </div>
        </div>
      </ModalPreGameCard>
      <ModalPreGameCard onCancel={onEnd}>
        <div>
          <Title />
          <br /> <br />
          <div className="f-modal-pre-game__flex-wrapper">
            <figure>
              <img src={images_modal.snake_preview_2} />
            </figure>
            <aside>
              <Controls className=" --snake-pc" />
              <br />
              <Button onClick={handlerCallToAction} title="¡Quiero jugar ya!">
                ¡Quiero jugar ya!
              </Button>
            </aside>
          </div>
        </div>
      </ModalPreGameCard>
    </AppSlider>
  )
}
const PreGameSnake = ({ onEnd }) => {
  const isMobile = useMediaQuery()
  return isMobile ? (
    <MobileVersion onEnd={onEnd} />
  ) : (
    <PcVersion onEnd={onEnd} />
  )
}

export default PreGameSnake
